import { gql } from '@apollo/client';

const CATEGORY_FIELDS = gql`
  fragment CategoryFields on Category {
    id
    name
    kind
    parent_id
    status
    sort_order
    created_at
    updated_at
  }
`;

export const CATEGORIES_QUERY = gql`
  ${CATEGORY_FIELDS}
  query Categories(
    $offset: Int
    $limit: Int
    $search: String
    $status_filter: CatalogStatusFilter
    $kind: CategoryKind
  ) {
    categories(
      offset: $offset
      limit: $limit
      search: $search
      status_filter: $status_filter
      kind: $kind
    ) {
      items {
        ...CategoryFields
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const CREATE_CATEGORY_MUTATION = gql`
  ${CATEGORY_FIELDS}
  mutation CreateCategory($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      ...CategoryFields
    }
  }
`;

export const UPDATE_CATEGORY_MUTATION = gql`
  ${CATEGORY_FIELDS}
  mutation UpdateCategory($id: ID!, $input: UpdateCategoryInput!) {
    updateCategory(id: $id, input: $input) {
      ...CategoryFields
    }
  }
`;

export const SET_CATEGORY_STATUS_MUTATION = gql`
  ${CATEGORY_FIELDS}
  mutation SetCategoryStatus($id: ID!, $status: String!) {
    setCategoryStatus(id: $id, status: $status) {
      ...CategoryFields
    }
  }
`;
